import React from "react";

const Icon = ({
  children,
  size,
  onShareToNetwork,
  linkOfArticleToShare,
  articleName,
}) => {
  let iconSize;
  if (size === "small") iconSize = "h-8 w-8";
  else if (size === "large") iconSize = "w-14 h-14";
  else iconSize = "w-10 h-10";
  return (
    <button
      onClick={(e) => onShareToNetwork(e, linkOfArticleToShare, articleName)}
      className={`${iconSize} animate flex  cursor-pointer items-center justify-center rounded-full border-2 border-secondary bg-white p-2 text-center font-extrabold text-secondary hover:bg-secondary hover:text-white`}
    >
      {children}
    </button>
  );
};

export default React.memo(Icon);
